import { useInView } from '@/hooks/useInView';
import { useCountUp } from '@/hooks/useCountUp';
import { stats } from '@/mocks/services';
import Stars from '@/components/base/Stars';

interface StatItemProps {
  stat: (typeof stats)[number];
  start: boolean;
}

function StatItem({ stat, start }: StatItemProps) {
  const raw = useCountUp(stat.value, start, 1600);
  const display =
    stat.decimals > 0
      ? raw.toFixed(stat.decimals).replace('.', ',')
      : Math.round(raw).toString();

  return (
    <div className="flex flex-col items-center text-center px-6 py-2">
      <span className="font-heading text-5xl md:text-6xl font-semibold leading-none text-background-50 tabular-nums">
        {display}
      </span>
      {stat.id === 'rating' ? (
        <Stars size="text-base mt-3" animated start={start} />
      ) : (
        <span className="mt-3 inline-flex h-4 items-center font-label text-xs uppercase tracking-[0.22em] text-accent-400">
          {stat.sub}
        </span>
      )}
      <span className="mt-3 font-label text-sm font-semibold text-background-100/90">{stat.label}</span>
    </div>
  );
}

export default function StatsBar() {
  const { ref, inView } = useInView<HTMLDivElement>(0.35);

  return (
    <section className="relative bg-primary-900 border-t border-accent-500/20">
      <div ref={ref} className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 sm:divide-x divide-background-50/10 divide-y sm:divide-y-0 max-w-4xl mx-auto">
          {stats.map((stat) => (
            <StatItem key={stat.id} stat={stat} start={inView} />
          ))}
        </div>
      </div>
    </section>
  );
}